module.exports = __webpack_public_path__ + "img/logo2.de7e1741.png";